import { render, staticRenderFns } from "./ProxyWallet.vue?vue&type=template&id=08d25498&scoped=true"
import script from "./ProxyWallet.vue?vue&type=script&lang=js"
export * from "./ProxyWallet.vue?vue&type=script&lang=js"
import style0 from "./ProxyWallet.vue?vue&type=style&index=0&id=08d25498&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d25498",
  null
  
)

export default component.exports